/** @internal */
export const OP_PULLED = "Pulled";
/** @internal */
export const OP_NO_UPSTREAM = "NoUpstream";
//# sourceMappingURL=channelUpstreamPullRequest.js.map